import LocationContainer from 'bento-ordering/locations/containers/LocationsContainer';
import LocationOfflineContainer from 'bento-ordering/locations/containers/LocationOfflineContainer';

import {
  LOCATION_BASE,
  LOCATION_DETAIL,
  LOCATION_OFFLINE,
  LOCATION_ASAP_OFFLINE
} from 'bento-ordering/locations/constants/paths';
import LocationOfflinePageLayout from 'bento-ordering/locations/layouts/LocationOfflinePageLayout';
import LocationListOuterLayout from 'bento-ordering/locations/layouts/LocationListOuterLayout';
import AsapNotCurrentlyAvailableOffline from 'bento-ordering/locations/containers/AsapNotCurrentlyAvailableOffline';
import { generatePath } from 'bento-ordering/utils/generatePath';
import { MENU } from 'bento-ordering/menus/constants/entities';

const routes = [
  {
    path: LOCATION_BASE,
    exact: true,
    Component: LocationContainer,
    Layout: LocationListOuterLayout
  },
  {
    path: LOCATION_OFFLINE,
    exact: true,
    Component: LocationOfflineContainer,
    Layout: LocationOfflinePageLayout
  },
  {
    path: LOCATION_ASAP_OFFLINE,
    exact: true,
    Component: AsapNotCurrentlyAvailableOffline,
    Layout: LocationOfflinePageLayout
  },
  {
    path: LOCATION_DETAIL,
    exact: true,
    redirect: ({ slug }) => generatePath(MENU, 'menu', { slug })
  }
];

export default routes;
